(function () {
  function init(drawer) {
    if (!drawer || drawer.dataset.speckshopReady === 'true') return;
    drawer.dataset.speckshopReady = 'true';

    var stack = ['root'];
    var resetTimer = null;

    function show(name, focusBack) {
      var current = null;
      drawer.querySelectorAll('[data-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-panel') === name;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
          current = panel;
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      var scroller = drawer.querySelector('.speckshop-drawer__panels');
      if (scroller) scroller.scrollTop = 0;

      if (focusBack && current) {
        var back = current.querySelector('[data-drawer-back]');
        if (back) back.focus();
      }
    }

    function closeSearch() {
      var search = drawer.querySelector('[data-speckshop-search]');
      var toggle = drawer.querySelector('[data-speckshop-search-toggle]');
      if (search) search.setAttribute('hidden', '');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function reset() {
      stack = ['root'];
      show('root', false);
      closeSearch();
    }

    drawer.addEventListener('click', function (event) {
      var searchToggle = event.target.closest('[data-speckshop-search-toggle]');
      if (searchToggle && drawer.contains(searchToggle)) {
        var search = drawer.querySelector('[data-speckshop-search]');
        if (!search) return;
        var willOpen = search.hasAttribute('hidden');
        if (willOpen) {
          search.removeAttribute('hidden');
          searchToggle.setAttribute('aria-expanded', 'true');
          var input = search.querySelector('input[type="search"]');
          if (input) input.focus();
        } else {
          closeSearch();
        }
        return;
      }

      var opener = event.target.closest('[data-open-panel]');
      if (opener && drawer.contains(opener)) {
        var name = opener.getAttribute('data-open-panel');
        if (!name) return;
        stack.push(name);
        show(name, true);
        return;
      }

      var back = event.target.closest('[data-drawer-back]');
      if (back && drawer.contains(back)) {
        if (stack.length > 1) stack.pop();
        var previous = stack[stack.length - 1] || 'root';
        show(previous, previous !== 'root');
      }
    });

    var body = document.body;
    var wasOpen = body.classList.contains('nav--is-visible');

    function onVisibility() {
      var open = body.classList.contains('nav--is-visible');
        if (open) {
        if (resetTimer) {
          window.clearTimeout(resetTimer);
          resetTimer = null;
        }
        wasOpen = true;
        pinDrawer();
        return;
      }

      if (!wasOpen) return;
      wasOpen = false;
      resetTimer = window.setTimeout(function () {
        if (!body.classList.contains('nav--is-visible')) reset();
      }, 300);
    }

    var nav = drawer.closest('.nav-hamburger');

    function pinDrawer() {
      if (!nav || !window.visualViewport) return;
      if (!body.classList.contains('nav--is-visible')) {
        nav.style.top = '';
        nav.style.height = '';
        return;
      }
      nav.style.top = window.visualViewport.offsetTop + 'px';
      nav.style.height = window.visualViewport.height + 'px';
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', pinDrawer);
      window.visualViewport.addEventListener('scroll', pinDrawer);
    }
    window.addEventListener('scroll', pinDrawer);
    drawer._speckshopPin = pinDrawer;

    var searchInput = drawer.querySelector('#SpeckshopDrawerSearch');
    if (searchInput) {
      searchInput.addEventListener('focus', function () {
        window.scrollTo(0, 0);
        pinDrawer();
      });
    }

    var observer = new MutationObserver(onVisibility);
    observer.observe(body, { attributes: true, attributeFilter: ['class'] });
    drawer._speckshopObserver = observer;
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-speckshop-drawer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

    document.addEventListener('shopify:section:unload', function (event) {
    var drawer = event.target.querySelector('[data-speckshop-drawer]');
    if (!drawer) return;
    if (drawer._speckshopObserver) drawer._speckshopObserver.disconnect();
    if (drawer._speckshopPin && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', drawer._speckshopPin);
      window.visualViewport.removeEventListener('scroll', drawer._speckshopPin);
      window.removeEventListener('scroll', drawer._speckshopPin);
    }
  });
})();
